// 유저 랭킹에 따른 닉네임 색상. iOS 의 UserProfileManager 와 동일한 규칙을 사용한다.
// 랭킹이 없거나 50위 밖이면 undefined 를 돌려줘 기존 스타일 색상을 그대로 쓴다.
export function getRankColor(rank: number | null | undefined): string | undefined {
  if (rank === null || rank === undefined) return undefined;
  if (rank === 1) return "var(--color-rank-first)";
  if (rank >= 2 && rank <= 10) return "var(--color-rank-top10)";
  if (rank >= 11 && rank <= 50) return "var(--color-rank-top50)";
  return undefined;
}
